import moment from "moment";
export var initStateReportProductDoData = {
    startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    isAllProduct: false,
    dimBranchIDList: [],
    dimProductPriceIDList: []
};
export var testReportProductDoData = [
    {
        id: 5632,
        sku: null,
        barcode: "8858705613436",
        name_th: "คาร์เนชัน นมข้นจืดเอ็กซ์ตร้ากล่อง 1ลิตร",
        name_en: "คาร์เนชัน นมข้นจืดเอ็กซ์ตร้ากล่อง 1ลิตร",
        supplier_names: null,
        supplier_code: null,
        formula_id: null,
        family_id: null,
        category_id: 1,
        sub_category_id: 1,
        sub_category_2_id: 5,
        divition_id: null,
        brand_id: 22,
        desc: null,
        sub_unit_id: 9,
        unit_id: 2,
        ratio_sub_unit: 12,
        sub_unit_cost: 56.76,
        unit_cost: 681.12,
        vat: "VAT 7%",
        minimum_sales: null,
        packing_size_name_th: "ลิตร",
        packing_size_th: 1,
        packing_size_name_en: null,
        packing_size_en: null,
        registration_number: null,
        tisi: null,
        weight: null,
        weight_name: null,
        wide: null,
        long: null,
        height: null,
        dimension_unit: null,
        storage_id: null,
        initial_product_quantity: null,
        minimum_alert: null,
        over_stock: null,
        is_able_sell_negative: null,
        remark: null,
        user_id: 13,
        is_web: false,
        is_closed: false,
        is_delete: false,
        created_at: "2022-09-19T03:58:31.000Z",
        updated_at: "2024-03-22T07:57:05.000Z",
        deleted_at: null,
        barcodes: [
            "8858705613436",
            "18858705613440"
        ],
        ums: {
            ratio_unit: 1,
            unit_name: "กล่อง"
        },
        uml: {
            ratio_unit: 12,
            unit_name: "ลัง"
        },
        min_avg_discount_before_vat: 0,
        max_avg_discount_before_vat: 0,
        branches: [
            {
                dim_branch_id: 1,
                dimMstBranch: {
                    id: 1,
                    branch_code: "CRI-001",
                    name: "พาน"
                },
                sold_total_ums: 0,
                sold_uml: 0,
                sold_ums: 0,
                sum_total_price_before_vat: 0
            },
            {
                dim_branch_id: 3,
                dimMstBranch: {
                    id: 3,
                    branch_code: "PYO-001",
                    name: "สำนักงานใหญ่"
                },
                sold_total_ums: 0,
                sold_uml: 0,
                sold_ums: 0,
                sum_total_price_before_vat: 0
            }
        ]
    },
    {
        id: 7222,
        sku: "-",
        barcode: "8859248921309",
        name_th: "Nextech TRB901-4 กล่องเบนโตะ4ช่อง สีแดง-ดำ 1070ml.+ฝาซีล 25ชุด",
        name_en: "Nextech TRB901-4 กล่องเบนโตะ4ช่อง สีแดง-ดำ 1070ml.+ฝาซีล 25ชุด",
        supplier_names: [
            "testName1"
        ],
        supplier_code: "BBB1234",
        formula_id: null,
        family_id: null,
        category_id: 4,
        sub_category_id: 14,
        sub_category_2_id: 42,
        divition_id: null,
        brand_id: 2,
        desc: null,
        sub_unit_id: 6,
        unit_id: 2,
        ratio_sub_unit: 8,
        sub_unit_cost: 120,
        unit_cost: 960,
        vat: "VAT 7%",
        minimum_sales: null,
        packing_size_name_th: "มิลลิลิตร",
        packing_size_th: 1070,
        packing_size_name_en: null,
        packing_size_en: null,
        registration_number: null,
        tisi: null,
        weight: null,
        weight_name: null,
        wide: null,
        long: null,
        height: null,
        dimension_unit: null,
        storage_id: null,
        initial_product_quantity: null,
        minimum_alert: null,
        over_stock: null,
        is_able_sell_negative: null,
        remark: null,
        user_id: 34,
        is_web: false,
        is_closed: false,
        is_delete: false,
        created_at: "2024-05-13T09:30:24.000Z",
        updated_at: "2025-03-25T18:13:57.000Z",
        deleted_at: null,
        barcodes: [
            "8859248921309",
            "8859248971861"
        ],
        ums: {
            ratio_unit: 1,
            unit_name: "แพ็ค"
        },
        uml: {
            ratio_unit: 8,
            unit_name: "ลัง"
        },
        min_avg_discount_before_vat: 0,
        max_avg_discount_before_vat: 0,
        branches: [
            {
                dim_branch_id: 1,
                dimMstBranch: {
                    id: 1,
                    branch_code: "CRI-001",
                    name: "พาน"
                },
                sold_total_ums: 0,
                sold_uml: 0,
                sold_ums: 0,
                sum_total_price_before_vat: 0
            },
            {
                dim_branch_id: 3,
                dimMstBranch: {
                    id: 3,
                    branch_code: "PYO-001",
                    name: "สำนักงานใหญ่"
                },
                sold_total_ums: 0,
                sold_uml: 0,
                sold_ums: 0,
                sum_total_price_before_vat: 0
            }
        ]
    },
    {
        id: 4591,
        sku: null,
        barcode: "8858773958392",
        name_th: "ฮีโร่ ถุงขยะแบบมาตรฐาน 18*20 (40ใบ)",
        name_en: "ฮีโร่ ถุงขยะแบบมาตรฐาน 18*20 (40ใบ)",
        supplier_names: null,
        supplier_code: null,
        formula_id: null,
        family_id: null,
        category_id: 4,
        sub_category_id: 14,
        sub_category_2_id: 51,
        divition_id: null,
        brand_id: 259,
        desc: null,
        sub_unit_id: 6,
        unit_id: 2,
        ratio_sub_unit: 40,
        sub_unit_cost: 26,
        unit_cost: 1040,
        vat: "VAT 7%",
        minimum_sales: null,
        packing_size_name_th: null,
        packing_size_th: null,
        packing_size_name_en: null,
        packing_size_en: null,
        registration_number: null,
        tisi: null,
        weight: null,
        weight_name: null,
        wide: null,
        long: null,
        height: null,
        dimension_unit: null,
        storage_id: null,
        initial_product_quantity: null,
        minimum_alert: null,
        over_stock: null,
        is_able_sell_negative: null,
        remark: null,
        user_id: null,
        is_web: false,
        is_closed: false,
        is_delete: false,
        created_at: "2021-10-29T05:47:02.000Z",
        updated_at: "2023-12-20T06:19:29.000Z",
        deleted_at: null,
        barcodes: [
            "8858773958392",
            "8858773959399",
            "18858773958392"
        ],
        ums: {
            ratio_unit: 1,
            unit_name: "แพ็ค"
        },
        uml: {
            ratio_unit: 40,
            unit_name: "ลัง"
        },
        min_avg_discount_before_vat: 1.4018700000000002,
        max_avg_discount_before_vat: 1.4018700000000002,
        branches: [
            {
                dim_branch_id: 1,
                dimMstBranch: {
                    id: 1,
                    branch_code: "CRI-001",
                    name: "พาน"
                },
                sold_total_ums: 0,
                sold_uml: 0,
                sold_ums: 0,
                sum_total_price_before_vat: 0
            },
            {
                dim_branch_id: 3,
                dimMstBranch: {
                    id: 3,
                    branch_code: "PYO-001",
                    name: "สำนักงานใหญ่"
                },
                sold_total_ums: 300,
                sold_uml: 7,
                sold_ums: 20,
                sum_total_price_before_vat: 420.5607
            }
        ]
    },
    {
        id: 7223,
        sku: "12233",
        barcode: "885929611",
        name_th: "ยูยี ผงโกโก้ 500g.+ซันเดย์ช็อกโกแลตท้อปปิ้ง 600g.",
        name_en: "ยูยี ผงโกโก้ 500g.+ซันเดย์ช็อกโกแลตท้อปปิ้ง 600g.",
        supplier_names: [
            "ทดสอบชื่อ"
        ],
        supplier_code: "ABC123",
        formula_id: null,
        family_id: null,
        category_id: 1,
        sub_category_id: 1,
        sub_category_2_id: 2,
        divition_id: null,
        brand_id: 17,
        desc: null,
        sub_unit_id: 21,
        unit_id: 2,
        ratio_sub_unit: 12,
        sub_unit_cost: 100,
        unit_cost: 1200,
        vat: "VAT 7%",
        minimum_sales: null,
        packing_size_name_th: null,
        packing_size_th: null,
        packing_size_name_en: null,
        packing_size_en: null,
        registration_number: null,
        tisi: null,
        weight: null,
        weight_name: null,
        wide: null,
        long: null,
        height: null,
        dimension_unit: null,
        storage_id: null,
        initial_product_quantity: null,
        minimum_alert: null,
        over_stock: null,
        is_able_sell_negative: null,
        remark: null,
        user_id: 34,
        is_web: false,
        is_closed: false,
        is_delete: false,
        created_at: "2024-05-14T08:07:17.000Z",
        updated_at: "2025-03-14T16:33:43.000Z",
        deleted_at: null,
        barcodes: [
            "885929611",
            "885929611X12"
        ],
        ums: {
            ratio_unit: 1,
            unit_name: "ชุด"
        },
        uml: {
            ratio_unit: 12,
            unit_name: "ลัง"
        },
        min_avg_discount_before_vat: 93.4579,
        max_avg_discount_before_vat: 93.45794166666667,
        branches: [
            {
                dim_branch_id: 1,
                dimMstBranch: {
                    id: 1,
                    branch_code: "CRI-001",
                    name: "พาน"
                },
                sold_total_ums: 0,
                sold_uml: 0,
                sold_ums: 0,
                sum_total_price_before_vat: 0
            },
            {
                dim_branch_id: 3,
                dimMstBranch: {
                    id: 3,
                    branch_code: "PYO-001",
                    name: "สำนักงานใหญ่"
                },
                sold_total_ums: 200,
                sold_uml: 16,
                sold_ums: 8,
                sum_total_price_before_vat: 18691.588699999997
            }
        ]
    }
];
